frappe.provide("strategic_gears.employee_approval");

strategic_gears.employee_approval.getContent = function(only_edit_on, action) {
    if (frappe.web_form.doc && frappe.web_form.doc.name) {
        frappe.call({
            method: "strategic_gears.employee_customization.web_form.employee_contract.web_form_utils.get_content",
            args: {
                doctype: frappe.web_form.doc.doctype,
                docname: frappe.web_form.doc.name,
                branch: frappe.web_form.doc.branch,
                only_edit_on: typeof only_edit_on === 'object' ? JSON.stringify(only_edit_on) : only_edit_on
            },
            callback: function (r) {
                console.log(r.message)
                if (r.message) {
                    let data = r.message;

                    if (data.errorMsg) {
                        $('.web-form-wrapper').html(`
                            <div class="alert alert-danger" role="alert" style="text-align: center; margin-top: 3rem; font-size: 16px;">
                                <strong>Error:</strong> ${data.errorMsg}
                            </div>
                        `);
                        $(".web-form-footer").remove();
                        $(".web-form-actions").remove();
                        return;
                    }

                    if (data.content) {
                        $('#print-format-content').html(data.content);
                    }

                    let current_path = window.location.pathname.replace(/\/+$/, "");
                    let is_edit_url = current_path.endsWith('/edit');
                    let base_path = is_edit_url ? current_path.replace('/edit', '') : current_path;

                    if (data.read_only_form === "Yes") {
                        if (is_edit_url) {
                            window.location.replace(base_path);
                            return;
                        }

                        $(".frappe-control").not(":has(#print-format-content)").remove();
                        $(".web-form-footer").remove();
                        $(".web-form-actions").remove();

                    } else {
                        if (!is_edit_url) {
                            window.location.replace(base_path + '/edit');
                            return;
                        }
                        updateActionButton(action);
                    }
                }
            }
        });
    }
}


strategic_gears.employee_approval.updateActionButton = function(workflow_action) {
    $('.btn-secondary, .btn-default').remove();
    $(".web-form-actions .btn-primary").remove();

    const $customBtn = $(`<button type="button" class="btn btn-primary btn-sm ml-2 custom-submit-btn">Submit</button>`);
    $(".web-form-actions").last().append($customBtn);

    $customBtn.on("click", function (e) {
        e.preventDefault();

        if (frappe.web_form.validate && !frappe.web_form.validate()) {
            return;
        }

        const values = frappe.web_form.get_values();
        if (!values) return;

        $customBtn.prop('disabled', true);

        frappe.call({
            method: "strategic_gears.employee_customization.web_form.employee_contract.web_form_utils.update_doc",
            args: {
                doctype: frappe.web_form.doc.doctype,
                docname: frappe.web_form.doc.name,
                data: values,
                workflow_action: workflow_action
            },
            callback: function (r) {
                if (!r.exc) {
                    strategic_gears.onboarding.showSuccessPage();
                } else {
                    $customBtn.prop('disabled', false);
                }
            }
        });
    });
}

strategic_gears.employee_approval.showSuccessPage = function() {
    let bodyText = `Submitted Successfully!`;

    $(".success-message").html(bodyText);
    $(".success-footer").empty();

    $(".success-footer").append(`
        <a href="/app" class="view-button btn btn-default btn-md">
            ${__("Go to Home")}
        </a>
    `);
    $(".web-form-container").hide();
    $(".success-page").removeClass("hide");
}